
        <div class="fx_404">
            <img src="assets/img/home/404.svg" />
            <div><a class="back-home" (click)="openHome()">回到首页</a></div>
        </div>
    